<template>
  <section class="social-proof">
    <v-container style="max-width: 1200px">
      <v-row justify="center" align="center" class="py-10">
        <v-col
          v-for="(stat, i) in stats"
          :key="i"
          cols="12"
          sm="3"
          class="text-center stat-col"
          :class="{ 'has-divider': i < stats.length - 1 }"
        >
          <p class="stat-value">{{ stat.value }}</p>
          <p class="stat-label">{{ $t(stat.labelKey) }}</p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'SocialProof',
  data() {
    return {
      stats: [
        { value: '300K+', labelKey: 'socialProof.stat1Label' },
        { value: '90K+', labelKey: 'socialProof.stat2Label' },
        { value: '40K+', labelKey: 'socialProof.stat3Label' },
        { value: '85K+', labelKey: 'socialProof.stat4Label' },
      ],
    }
  },
}
</script>

<style scoped>
.social-proof {
  background: #fff;
  border-top: 1px solid #eef0f8;
  border-bottom: 1px solid #eef0f8;
}

.stat-col { padding: 8px 32px; }

.stat-col.has-divider { border-right: 1px solid #e0e0e0; }

@media (max-width: 600px) {
  .stat-col.has-divider {
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
  }
}

.stat-value {
  font-size: 2.4rem;
  font-weight: 900;
  color: #F77317;
  margin: 0;
  letter-spacing: -1px;
  line-height: 1.1;
}

.stat-label {
  font-size: 0.88rem;
  font-weight: 500;
  color: #888;
  margin: 6px 0 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
